import axios from 'axios';

export const listVouchers = async ({ headers, eventId }) => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_API_VOUCHER_BASE_URL}/${eventId}`, {
      headers
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const createVoucher = async ({ headers, payload }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_API_VOUCHER_BASE_URL}/`, payload, {
      headers
    });
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateVoucher = async ({ headers, payload, voucherId }) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_VOUCHER_BASE_URL}/${voucherId}`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const updateVoucherMany = async ({ headers, payload }) => {
  const eventId = payload.event._id;

  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_API_VOUCHER_BASE_URL}/${eventId}/update/many`,
      payload,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};

export const deleteVoucher = async ({ headers, voucherId }) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_API_VOUCHER_BASE_URL}/${voucherId}`,
      { headers }
    );
    return response.data;
  } catch (err) {
    if (err.response) {
      throw new Error(err.response.data.message);
    } else {
      throw new Error(err.message);
    }
  }
};
